import { Box, IconButton, Image } from '@chakra-ui/react';
import useAppSelector from 'hooks/shared/store/useAppSelector';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FC, useState } from 'react';
import { authSelector } from 'selectors/modules/auth';
import { isWidgetChatOpenedSelector, selectedWidgetChatSelector } from 'selectors/modules/chat/widgetChat';
import { AuthStatus } from 'slices/modules/auth/authState';
import ChatDetailWidgetContainer from './detail/ChatDetailWidgetContainer';
import ChatListWidgetContainer from './list/ChatListWidgetContainer';

import closeChatIcon from 'assets/img/icons/close-chat-widget.svg';
import openChatIcon from 'assets/img/icons/open-chat-widget.svg';
import { useFetchChatListQuery } from 'rtkQuery/sharespro/queries/chat';
import { Color } from 'presentation/theme/colorScheme';
import { useDispatch } from 'react-redux';
import { widgetChatSlice } from 'slices/modules/chat/widgetChatSlice';

const ChatWidget: FC = () => {
  const [page, setPage] = useState<number>(1);
  const selectedChatData = useAppSelector(selectedWidgetChatSelector);
  const isWidgetChatOpened = useAppSelector(isWidgetChatOpenedSelector);
  const { status: authStatus } = useAppSelector(authSelector);
  const dispatch = useDispatch();

  const { data: chatList } = useFetchChatListQuery({ page });

  if (authStatus !== AuthStatus.LoggedIn) {
    return null;
  }

  return (
    <Box
      position="fixed"
      right="40px"
      bottom="40px"
      zIndex="100"
      display="flex"
      flexDir="column"
      alignItems="flex-end"
    >
      <AppCard
        display={isWidgetChatOpened ? 'block' : 'none'}
        w="420px"
        h="70vh"
        maxH="584px"
        boxShadow="0px 0px 30px rgba(0, 0, 0, 0.2)"
        overflow="hidden"
      >
        {selectedChatData ? (
          <ChatDetailWidgetContainer />
        ) : (
          <ChatListWidgetContainer page={page} setPage={setPage} />
        )}
      </AppCard>
      <Box pos="relative" w="60px" h="60px" mt="20px">
        <IconButton
          pos="relative"
          aria-label=""
          rounded="50%"
          onClick={() => dispatch(widgetChatSlice.actions.toggle())}
          icon={
            isWidgetChatOpened ? (
              <Image src={closeChatIcon} w="60px" h="60px" />
            ) : (
              <Image src={openChatIcon} w="60px" h="60px" />
            )
          }
          w="60px"
          h="60px"
          boxShadow="0px 0px 30px rgba(0, 0, 0, 0.2)"
        />
        {typeof chatList?.totalUnreadMessages === 'number' &&
          chatList?.totalUnreadMessages > 0 &&
          !isWidgetChatOpened && (
            <Box
              pos="absolute"
              right={0}
              top="-10px"
              bgColor={Color.Danger400}
              color={Color.OnDanger}
              borderRadius="50%"
              px="5px"
              minW="24px"
              h="24px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {chatList?.totalUnreadMessages}
            </Box>
          )}
      </Box>
    </Box>
  );
};

export default ChatWidget;
